import { Box, Button, Paper, Stack, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material'
import { useOnboarding } from '../../context/OnboardingContext'
import type { BorStateStatus } from '../../types/onboarding'
import { MISC_PRIMARY } from '../../theme/onboardingTheme'

const statusLabel: Record<BorStateStatus, string> = {
  not_started: 'Not started',
  generated: 'Generated',
  uploaded: 'Uploaded',
  misc_reviewed: 'MISC reviewed ✓',
}

export function StepBor() {
  const { state, dispatch } = useOnboarding()

  return (
    <Stack spacing={3}>
      <Typography sx={{ fontSize: 14, color: '#475569' }}>
        ACORD 36-style letters are mocked here. Download placeholders, then mark upload to simulate
        the return path from the prior broker.
      </Typography>
      <Paper
        variant="outlined"
        sx={{
          overflowX: 'auto',
          borderColor: '#e2e8f0',
          borderRadius: '12px',
          backgroundColor: '#ffffff',
          boxShadow: 1,
        }}
      >
        <Table sx={{ minWidth: 480 }} size="small">
          <TableHead>
            <TableRow sx={{ backgroundColor: '#f8fafc' }}>
              <TableCell sx={{ px: 1.5, py: 1, fontSize: 12, fontWeight: 600, textTransform: 'uppercase', color: '#64748b' }}>
                State
              </TableCell>
              <TableCell sx={{ px: 1.5, py: 1, fontSize: 12, fontWeight: 600, textTransform: 'uppercase', color: '#64748b' }}>
                Status
              </TableCell>
              <TableCell sx={{ px: 1.5, py: 1, fontSize: 12, fontWeight: 600, textTransform: 'uppercase', color: '#64748b' }}>
                Actions
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {state.borRows.map((row) => (
              <TableRow key={row.stateCode} sx={{ '& td': { borderTop: '1px solid #f1f5f9' } }}>
                <TableCell sx={{ px: 1.5, py: 1, fontSize: 14, fontWeight: 600 }}>
                  {row.stateCode}
                </TableCell>
                <TableCell sx={{ px: 1.5, py: 1, fontSize: 12 }}>
                  {statusLabel[row.status]}
                </TableCell>
                <TableCell sx={{ px: 1.5, py: 1 }}>
                  <Stack direction="row" flexWrap="wrap" spacing={1}>
                    <Button
                      type="button"
                      variant="outlined"
                      onClick={() => {
                        dispatch({ type: 'BOR_STATUS', stateCode: row.stateCode, status: 'generated' })
                        dispatch({ type: 'TOAST', message: `BOR PDF ready for ${row.stateCode} (mock).` })
                      }}
                      sx={{
                        minWidth: 0,
                        borderColor: '#e2e8f0',
                        px: 1,
                        py: 0.5,
                        fontSize: 12,
                        fontWeight: 600,
                        color: '#0f172a',
                        '&:hover': { backgroundColor: '#f8fafc' },
                      }}
                    >
                      Generate BOR
                    </Button>
                    <Box
                      component="label"
                      sx={{
                        display: 'inline-flex',
                        cursor: 'pointer',
                        alignItems: 'center',
                        gap: 0.5,
                        borderRadius: '4px',
                        border: '1px dashed rgba(37, 99, 235, 0.4)',
                        px: 1,
                        py: 0.5,
                        fontSize: 12,
                        fontWeight: 600,
                        color: MISC_PRIMARY,
                        '&:hover': { backgroundColor: '#eff6ff' },
                      }}
                    >
                      <Box
                        component="input"
                        type="file"
                        sx={{ display: 'none' }}
                        onChange={() =>
                          dispatch({ type: 'BOR_STATUS', stateCode: row.stateCode, status: 'uploaded' })
                        }
                      />
                      Upload signed
                    </Box>
                  </Stack>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Paper>
    </Stack>
  )
}
